// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Gallery = ((() => {
  // try to declare variables that are going to be used to improve performance

  // in this function you get all the div elements that need to be manipulated
  function init() {
    // eslint-disable-next-line no-undef
    Fancybox.bind('[data-fancybox]', {
      caption: false,
      loop: true,              // Navigate past the last item back to first
      arrows: window.innerWidth > 768,            // Show navigation arrows o desktop only
      keyboard: true,          // Use keyboard arrows to navigate
      infinite: false,         // Disable infinite zoom
      Toolbar: {
        display: {
          left: ['infobar'],    // Shows "Image 1 of 4"
          middle: [],
          right: ['slideshow', 'thumbs', 'close']
        }
      },
      Carousel: {
        transition: 'slide'     // Slide transition between images
      }
    });


  }



  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default Gallery;



// WEBPACK FOOTER //
// ./src/static/js/modules/gallery.js